import React from 'react';
import RaisedButton from 'material-ui/RaisedButton/index';
import styled, { withTheme } from 'styled-components';

import Card from './Card';

const CenteredCard = styled.div`
  padding: ${({ theme }) => theme.metrics.margin}px 0;
`;

const SplashImage = styled.img`
  height: 200px;
  margin: 25px;
`;

const VerticalCenteredCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 0
`;

const SplashTitle = styled.strong`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 24px;
  padding: 10px
`;

const SplashText = styled.div`
  font-size: 20px;
  text-align: center;
  padding: 10px;
`;

const PaddedSplashButton = styled.div`
  padding: 25px;
  text-align: center;
`;

const SplashButton = styled(RaisedButton)`
  width: 300px;
  display: flex;
  flex-direction: column;
  margin: auto;
`;

type Props = {
  image: string,
  title: string,
  text: string,
  buttonText: string,
  onButtonClick: () => any,
}

const SplashCard = ({
  image, title, text, buttonText, onButtonClick,
}: Props) => {
  return (<CenteredCard>
    <VerticalCenteredCard>
      <SplashImage src={image} />
      <SplashTitle>{title}</SplashTitle>
      <SplashText>{text}</SplashText>
      <PaddedSplashButton>
        <SplashButton label={buttonText} onClick={onButtonClick} primary />
      </PaddedSplashButton>
    </VerticalCenteredCard>
  </CenteredCard>);
};

export default withTheme(SplashCard);



// WEBPACK FOOTER //
// ./src/common/components/SplashCard.js